import styled from 'styled-components'

export const DivWrapperItems = styled.div`
  width: 100%;
`
export const DivWrapperLoader = styled.div`
  margin-top: 5px;
`
export const DivWrapperError = styled.div`
  margin-top: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.darkGrey};
`

export const StyledText = styled.text`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.darkGrey};
`

export const DivWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
`

export const DivWrapperEmployeeData = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`
